// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__LAd6d","overflowing":"ReadFullNote_overflowing__2Kyut"};